import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Popover, CardHeader, Divider, colors, IconButton
} from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import NotificationList from './NotificationList';
import Placeholder from './Placeholder';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: {
    width: 350,
    maxWidth: '100%'
  },
  actions: {
    backgroundColor: colors.grey[50],
    justifyContent: 'center'
  }
}));

const NotificationsPopover = ({
  notifications,
  onClickNotification,
  anchorEl,
  handleDeleteAll,
  ...rest
}) => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
    >
      <div className={classes.root}>
        <CardHeader
          className={classes.header}
          // action={(
          //   <IconButton color="primary" onClick={handleDeleteAll} disabled={notifications?.length === 0}>
          //     <DeleteForeverIcon />
          //   </IconButton>
          //             )}
          title={t("Bildirimler")}
        />
        <Divider />
        {(notifications !==undefined && notifications.length>0) ? (
          <NotificationList
            notifications={notifications}
            onClickNotification={onClickNotification}
          />
        ) : (
          <Placeholder />
        )}
      </div>
    </Popover>
  );
};

NotificationsPopover.propTypes = {
  anchorEl: PropTypes.any,
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired,
  onClickNotification: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default NotificationsPopover;
